import { useCallback } from "react";
import { requestPresignedUpload } from "../api/requestPresignedUpload";
import { mapFileToFileInfo } from "../utils/mapFileToFileInfo";
import { putToPresignedUrl } from "../utils/putToPresignedUrl";

/**
 * Presign + direct PUT to S3 for `POST community/{id}/assets`.
 *
 * @param {{
 *   communityId: number|string|null|undefined,
 *   onUploadingChange?: (uploading: boolean) => void
 * }} options
 */
export function useUploadCommunityAsset({ communityId, onUploadingChange }) {
  const uploadFile = useCallback(
    async (file, category) => {
      if (communityId == null || communityId === "") {
        throw new Error("communityId is required");
      }
      onUploadingChange?.(true);
      try {
        const file_info = mapFileToFileInfo(file);
        const { upload_url, final_url } = await requestPresignedUpload(communityId, {
          category,
          file_info,
        });
        await putToPresignedUrl(upload_url, file, file_info.content_type);
        return final_url;
      } finally {
        onUploadingChange?.(false);
      }
    },
    [communityId, onUploadingChange]
  );

  return { uploadFile };
}
